import { Box, BoxProps, IconButton, ModalDialog, Text, TextProps } from '@jfs/ui-new'

interface ModalDialogContainerProps {
  show: boolean
  onDismiss: any
  children?: any
  merchantId: string
}

export const ModalDialogContainer = ({ show, onDismiss, merchantId, children }: ModalDialogContainerProps) => {
  return (
    <ModalDialog show={show} onDismiss={onDismiss} type="CenteredWrap" >
      <Box {...styles.container}>
        <ModelDialogHeaders onDismiss={onDismiss} title={"Transaction Details"} />

        <Box {...styles.subHeadingConatainer}>
          <Text {...styles.subHeaderTitle}>Merchant Id: </Text>
          <Text {...styles.subHeaderTitle} color={'BLACK_75'} fontFamily="jioType-medium">
            {merchantId}
          </Text>
        </Box>
        <Box overflow='auto' flex={1} nativeID="vertical-scroll">
          {children}
        </Box>
      </Box>
    </ModalDialog>
  )
}

export const ModelDialogHeaders = ({ onDismiss, title }) => {
  return (
    <Box {...styles.header}>
      <Text {...styles.headerTitle}> {title}</Text>
      <IconButton id={'CLOSE'} onPress={onDismiss} color="WHITE" size={24} />
    </Box>
  )
}

const styles = {
  container: {
    backgroundColor: 'WHITE',
    width: '90vw',
    height: '90vh',
    borderRadius: 8,
    overflow: "hidden",
  } as BoxProps,
  header: {
    ph: 16,
    pv: 8,
    backgroundColor: 'PRIMARY',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  } as BoxProps,
  headerTitle: {
    fontSize: 16,
    fontFamily: 'jioType-bold',
    color: 'WHITE',
  } as TextProps,
  subHeaderTitle: {
    fontSize: 18,
    fontFamily: 'jioType-bold',
    color: 'BLACK_21',
  } as TextProps,
  subHeadingConatainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    padding: 16,
  } as BoxProps,
}
